import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios/index'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loggedUser: Laravel.user,
        counter: 0,
        emptyFields: false,
        emptyTechnologies: false,
        responseMessage: '',
        responseFailure: false,
        shuffledWidths: [],
        addedTechnologies: []
    },
    getters: {
        getLoggedUser: (state) => {
            return state.loggedUser
        },
        getCounter: (state) => {
            return state.counter
        },
        getEmptyFields: (state) => {
            return state.emptyFields
        },
        getEmptyTechnologies: (state) => {
            return state.emptyTechnologies
        },
        getResponseMessage: (state) => {
            return state.responseMessage
        },
        getResponseFailure: (state) => {
            return state.responseFailure
        },
        getShuffledWidths: (state) => {
            return state.shuffledWidths
        },
        getAddedTechnologies: (state) => {
            return state.addedTechnologies
        },
    },
    mutations: {
        setLoggedUser: (state, val) => {
            return state.loggedUser = val
        },
        setCounter: (state, val) => {
            return state.counter = val
        },
        setEmptyFields: (state, val) => {
            return state.emptyFields = val
        },
        setEmptyTechnologies: (state, val) => {
            return state.emptyTechnologies = val
        },
        setResponseMessage: (state, val) => {
            return state.responseMessage = val
        },
        setResponseFailure: (state, val) => {
            return state.responseFailure = val
        },
        setShuffledWidths: (state, val) => {
            return state.shuffledWidths = val
        },
        setAddedTechnologies: (state, val) => {
            return state.addedTechnologies = val
        },
    },
    actions: {
        getDeveloperTechnologies({ commit, getters, state }) {
            return new Promise((resolve, reject) => {
                axios.get(Laravel.baseURL + '/get-technologies/dev',{
                    }).then(function (response) {
                        //All good
                        resolve(response)
                    }).catch(function (error) {
                        reject(error.response.data.message)
                })
            }) 
        },
        getOtherTechnologies({ commit, getters, state }) {
            return new Promise((resolve, reject) => {
                axios.get(Laravel.baseURL + '/get-technologies/other',{
                    }).then(function (response) {
                        //All good
                        resolve(response)
                    }).catch(function (error) {
                        reject(error.response.data.message)
                })
            }) 
        },
    }
})
